import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { circleXmark } from '@ibk/shared-assets';
import styles from './AppliedFilterChip.module.css';
export function AppliedFilterChip({ label, onRemove, removeAriaLabel, chipTestId, labelTestId, removeTestId, }) {
    return (_jsxs("div", { className: styles.filterChip, "data-testid": chipTestId, children: [_jsx("span", { className: styles.filterChipText, "data-testid": labelTestId, children: label }), _jsx("button", { type: 'button', className: styles.filterChipCloseButton, onClick: onRemove, "data-testid": removeTestId, "aria-label": removeAriaLabel, children: _jsx("img", { src: circleXmark, alt: '' }) })] }));
}
